"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminTestUg = exports.AdminTestUgInternal = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const SkeletonComponent_1 = require("src/hello_assets/src/components/ui/common/common/SkeletonComponent");
const antd_1 = require("antd");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const lodash_1 = __importDefault(require("lodash"));
const usergeek_ic_js_1 = require("usergeek-ic-js");
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const react_dom_1 = require("react-dom");
const geekfactory_ic_js_auth_1 = require("geekfactory-ic-js-auth");
const AdminTestUgInternal = () => {
    const authProviderContext = (0, geekfactory_ic_js_auth_1.useAuthProviderContext)();
    const currentPrincipal = authProviderContext.getCurrentPrincipal();
    const [initFinished, setInitFinished] = (0, react_1.useState)(false);
    const [apiKey, setApiKey] = (0, react_1.useState)(window.localStorage.getItem("tmp_test_ug_api_key") || "");
    const onClickInitializeUsergeek = (0, react_1.useCallback)(() => {
        if (!initFinished && !lodash_1.default.isEmpty(apiKey) && currentPrincipal) {
            usergeek_ic_js_1.Usergeek.init({
                apiKey: apiKey
            });
            usergeek_ic_js_1.Usergeek.setPrincipal(currentPrincipal);
            setInitFinished(true);
        }
    }, [initFinished, apiKey, currentPrincipal]);
    const initializeUsergeekButtonEnabled = lodash_1.default.size(apiKey) === 32;
    if (!initFinished) {
        return React.createElement(PageContent_1.default, null,
            React.createElement(PageContent_1.default.Card, null,
                React.createElement("h3", null, "Initialize Usergeek"),
                React.createElement("h5", null,
                    "Principal: ", currentPrincipal === null || currentPrincipal === void 0 ? void 0 :
                    currentPrincipal.toText()),
                React.createElement(antd_1.Space, { direction: "horizontal" },
                    React.createElement(antd_1.Input, { value: apiKey, placeholder: "ApiKey...", onChange: event => {
                            window.localStorage.setItem("tmp_test_ug_api_key", event.target.value || "");
                            setApiKey(event.target.value);
                        }, style: { width: 200 } }),
                    React.createElement(antd_1.Button, { disabled: !initializeUsergeekButtonEnabled, onClick: onClickInitializeUsergeek }, "Initialize SDK"))));
    }
    return React.createElement(UGInitializedStateComponent, { apiKey: apiKey });
};
exports.AdminTestUgInternal = AdminTestUgInternal;
const UGInitializedStateComponent = (props) => {
    var _a;
    const authProviderContext = (0, geekfactory_ic_js_auth_1.useAuthProviderContext)();
    const [eventName, setEventName] = (0, react_1.useState)("");
    const [dayShift, setDayShift] = (0, react_1.useState)(0);
    const onClickTrackSession = (0, react_1.useCallback)(() => {
        usergeek_ic_js_1.Usergeek.trackSession();
    }, [eventName]);
    const onClickTrackEvent = (0, react_1.useCallback)(() => {
        /**/ addDatePatch(dayShift);
        usergeek_ic_js_1.Usergeek.trackEvent(eventName);
        /**/ removeDatePatch();
        (0, react_dom_1.unstable_batchedUpdates)(() => {
            setEventName("");
            setDayShift(0);
        });
    }, [eventName, dayShift]);
    const onClickFlush = (0, react_1.useCallback)(() => {
        usergeek_ic_js_1.Usergeek.flush();
    }, []);
    return React.createElement(PageContent_1.default, null,
        React.createElement(PageContent_1.default.Card, null,
            React.createElement("h3", null,
                "Project ",
                props.apiKey),
            React.createElement("h5", null,
                "Principal: ", (_a = authProviderContext.getCurrentPrincipal()) === null || _a === void 0 ? void 0 :
                _a.toText()),
            React.createElement(antd_1.Space, { direction: "vertical", size: "large" },
                React.createElement(antd_1.Button, { onClick: onClickTrackSession }, "Track Session"),
                React.createElement(antd_1.Form, { layout: "vertical" },
                    React.createElement(antd_1.Row, { gutter: 10 },
                        React.createElement(antd_1.Col, null,
                            React.createElement(antd_1.Form.Item, { label: "Day Shift" },
                                React.createElement(antd_1.InputNumber, { value: dayShift, onChange: (value) => setDayShift(value), style: { width: 100 } }))),
                        React.createElement(antd_1.Col, null,
                            React.createElement(antd_1.Form.Item, { label: "Event Name" },
                                React.createElement(antd_1.Input, { value: eventName, placeholder: "Event...", onChange: event => setEventName(event.target.value), style: { width: 200 } }))),
                        React.createElement(antd_1.Col, null,
                            React.createElement(antd_1.Form.Item, { label: " " },
                                React.createElement(antd_1.Button, { onClick: onClickTrackEvent }, "Track"))))),
                React.createElement(antd_1.Button, { onClick: onClickFlush }, "Flush"))));
};
const AdminTestUg = () => React.createElement(SkeletonComponent_1.TestServerRenderComponent, null,
    React.createElement(exports.AdminTestUgInternal, null));
exports.AdminTestUg = AdminTestUg;
let dateGetTime_proto_copy = undefined;
const addDatePatch = (dayShift) => {
    dateGetTime_proto_copy = Date.prototype.getTime;
    const millis = DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDay().subtract(dayShift, "day").valueOf();
    Date.prototype.getTime = () => millis;
};
const removeDatePatch = () => {
    Date.prototype.getTime = dateGetTime_proto_copy;
};
